export default "__VITE_ASSET__C4S5mfyq__"